import React from 'react';
import { FormSection, Field } from '@atlaskit/form';
import { Currency } from '@css-xp/graphtypes';
import Textfield from '@atlaskit/textfield';
import { Checkbox } from '@atlaskit/checkbox';
import { DismissableInlineMessage } from '@css-xp/base';
import { InvoiceGroupWarnings } from '@atlassian/cssxp-types-billing';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import InfoIcon from '@atlaskit/icon/glyph/info';

interface CurrencyPONumberStepProps {
  isPONumberFeatureEnabled: boolean;
  isPOMultipleUseChecked: boolean;
  onPOMultipleUseChangeEvent?: () => void;
  purchaseOrderNumber?: string;
  hideCurrency?: boolean;
}

export const CurrencyPONumberStep = ({
  isPONumberFeatureEnabled,
  isPOMultipleUseChecked,
  onPOMultipleUseChangeEvent,
  purchaseOrderNumber,
  hideCurrency,
}: CurrencyPONumberStepProps) => {
  return (
    <>
      {!hideCurrency && (
        <FormSection>
          <div className="form-component-width" data-testid="currency-field">
            <h3>Currency</h3>
            <Field name="currency" isRequired id="currency" defaultValue={Currency.USD} isDisabled={true}>
              {({ fieldProps }) => <Textfield {...fieldProps} name="currency" testId="currency-usd" />}
            </Field>
          </div>
        </FormSection>
      )}
      <FormSection>
        {isPONumberFeatureEnabled && (
          <div className="form-component-width">
            <h3>Purchase order</h3>
            <Field
              name="purchaseOrderNumber"
              id="purchaseOrderNumber"
              label="Number"
              defaultValue={purchaseOrderNumber}
            >
              {({ fieldProps }) => (
                <Textfield
                  {...fieldProps}
                  name="purchaseOrderNumber"
                  testId="purchase-order-number"
                  onChange={(event) => {
                    fieldProps.onChange(event.currentTarget.value);
                  }}
                />
              )}
            </Field>
            <br />
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Checkbox
                isChecked={isPOMultipleUseChecked}
                onChange={onPOMultipleUseChangeEvent}
                label="Multiple Use PO Number"
                value="Multiple Use PO Number"
                name="multipleUse"
                testId="po-multiple-use"
              />
              <DismissableInlineMessage
                position="bottom-end"
                renderMessage={(dismissMessage) => (
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <p className="infoMessage">{InvoiceGroupWarnings.PO_MULTIPLE_USE_WARNING}</p>
                    <span
                      style={{ cursor: 'pointer', paddingLeft: '4px', paddingRight: '4px' }}
                      onClick={dismissMessage}
                    >
                      <CrossIcon label="Close" />
                    </span>
                  </div>
                )}
                renderTitle={(toggleMessage) => (
                  <span className="info-icon" onClick={toggleMessage}>
                    <InfoIcon label="Info" />
                  </span>
                )}
              />
            </div>
          </div>
        )}
      </FormSection>
    </>
  );
};
